module.exports = "<div class=\"form-group\">\r\n  <div *ngFor=\"let option of model\">\r\n    <spk-checkbox [(model)]=\"option.Selected\" [name]=\"'selector' + option.Text + option.Value\" [wrapped]=\"false\"></spk-checkbox>\r\n    <label class=\"form-check-label\" for=\"selector{{option.Text}}{{option.Value}}\">&nbsp;{{option.Text}}</label>\r\n  </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/framework/spk/controls/spk-value-text-checkboxlist/spk-value-text-checkboxlist.component.html
// module id = ./src/app/components/framework/spk/controls/spk-value-text-checkboxlist/spk-value-text-checkboxlist.component.html
// module chunks = main